export const PRINT = 'print';

export const DELETE_SHIFT_TURNOVER = 'delete-shift-turnover';

export const COMPLETE_REVIEW = 'complete-review';
export const RESOLVE_LOG = 'resolve-log';
export const DELETE_LOG = 'delete-log';
export const EMAIL_LOG = 'email-log';

export const VIEW_AUDIT = 'view-audit';
export const VIEW_HISTORICAL_RECORD = 'view-historical-record';
export const DELETE_LIST = 'delete-contact-list';

export const TROUBLESHOOT = 'view-troubleshooting';
export const PART_SEARCH = 'view-part-search';
export const DELETE_STATION_LOG = 'delete-station-log';

export const EDIT_NOTE = 'edit-controller-note';
export const DELETE_NOTE = 'delete-controller-note';
export const PRINT_NOTE = 'print-controller-note';
export const EMAIL_NOTE = 'email-controller-note';

export const CREATE_MOC_EVENT = 'create-moc-event';

export const MARK_USER_INACTIVE = 'mark-user-inactive';
